import React from 'react';
import Module from './Module';
import { FormControl, Input, RichEditor } from 'components';
import useReactRouter from 'use-react-router';

const OrderNote = (props) => {
	const { context } = props;
	const { validationErrors, state } = context;
	const { history } = useReactRouter();

	// if(history.location.pathname.indexOf("settings") === -1) return null

	return (
		<Module name="Order Note" {...props}>
			<FormControl
				label="Text :"
				marginBottom="mb-0"
				error={validationErrors['settings.modules.order_note.text']}
			>
				<RichEditor
					placeholder="Enter your text here!"
					BindToContext={[context, 'settings.modules.order_note.text']}
					hasError={!!validationErrors['settings.modules.order_note.text']}
				/>
			</FormControl>
		</Module>
	);
};

export default OrderNote;
